import { BaseComponent } from './views/layout/base/base.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {path: "", component: BaseComponent, children: [
    {path: "", redirectTo: "/home", pathMatch: "full"},
    {path: "", loadChildren: () => import("./views/pages/pages.module").then(m => m.PagesModule)}
  ]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
